export const MAKE_REQUEST = "USER_MAKE_REQUEST";
export const FAIL_REQUEST = "FAIL_REQUEST";
export const FETCH_SINGLE_USER = "FETCH_SINGLE_USER";
export const SET_EMPLOYEE_LIST = "SET_EMPLOYEE_LIST";
export const SET_DUPLICATE_USER_STATUS = "SET_DUPLICATE_USER_STATUS";
export const SET_EMPLOYEE_AS_UNIT_LIST = "SET_EMPLOYEE_AS_UNIT_LIST";
export const EMAIL_LOGS_LIST ='EMAIL_LOGS_LIST'
export const SET_USER_DATA="SET_USER_DATA"